import React from "react";
import { useController } from "react-hook-form";
import { Spinner } from "@/assets/svg/Spinner";
import { DropdownMultiSelect } from "@/components/FormInputs";
import { i18n } from "@/i18n";
import { InputWrapper } from "@/components/FormInputs/InputWrapper";
import {
  buildStartTermOptions,
  deconstructStartTerms,
  startTermsToOptionValue,
} from "../utils/startTerms";
import { FilterInput as FilterInputType } from "../types";
import { useCurrentCohortYear } from "@/hooks/useCurrentCohortYear";

export function StartTermInput({
  cohortYears,
  entryTerms,
  disabled,
}: {
  cohortYears: FilterInputType;
  entryTerms: FilterInputType;
  disabled: boolean;
}) {
  const {
    field,
    fieldState: { error },
  } = useController({ name: "filters.startTerm" });
  const { cohortYear: currentCohortYear } = useCurrentCohortYear();

  const options = buildStartTermOptions(
    cohortYears,
    entryTerms,
    currentCohortYear,
  );

  if (options.length) {
    return (
      <InputWrapper
        label={i18n.t("filters.startTerm")}
        name="startTerm"
        error={error}
      >
        <DropdownMultiSelect
          options={options}
          value={startTermsToOptionValue(field.value || [])}
          onUpdate={(value) => field.onChange(deconstructStartTerms(value))}
          placeholder={i18n.t("filters.selectStartTerm")}
          allowSearch={false}
          disabled={disabled}
        />
      </InputWrapper>
    );
  }

  return <Spinner />;
}
